function applyClass(check, ruleTextSelector) {
    if (check) {
        $(ruleTextSelector).addClass('pw-restriction-checked');
        $(ruleTextSelector + '-icon').removeClass('hide');
    } else {
        $(ruleTextSelector).removeClass('pw-restriction-checked');
        $(ruleTextSelector + '-icon').addClass('hide');
    }
}

$(function () {

    var pwLength = $('#pw-restriction-password-length').attr("data-password-length");
    var pwAllowUnicode = $('#pw-allow-unicode').attr("data-allow-unicode") === "True";

    var pwUpper = $('#pw-restriction-upper-case').attr("data-upper-case");
    var pwLower = $('#pw-restriction-lower-case').attr("data-lower-case");
    var pwDigits = $('#pw-restriction-digits').attr("data-digits");
    var pwLetters = $('#pw-restriction-letters').attr("data-letters");
    var pwSymbols = $('#pw-restriction-symbols').attr("data-symbols");

    var pwUpperRegex = null;
    var pwLowerRegex = null;
    var pwDigitsRegex = null;
    var pwLettersRegex = null;
    var pwSymbolsRegex = null;


    if(pwAllowUnicode) {
        if (pwUpper != null) {
            pwUpperRegex = new RegExp("(?:[^/\\p{Lu}]*[/\\p{Lu}]){" + pwUpper + "}", "u");
        }
        if (pwLower != null) {
            pwLowerRegex = new RegExp("(?:[^/\\p{Ll}]*[/\\p{Ll}]){" + pwLower + "}", "u");
        }
        if (pwDigits != null) {
            pwDigitsRegex = new RegExp("(?:[^/\\p{Nd}]*[/\\p{Nd}]){" + pwDigits + "}", "u");
        }
        if (pwLetters != null) {
            pwLettersRegex = new RegExp("(?:[^/\\p{L}]*[/\\p{L}]){" + pwLetters + "}", "u");
        }
        if (pwSymbols != null) {
            pwSymbolsRegex = new RegExp("(?:.*?[^/\\p{L}/\\p{Nd}]){" + pwSymbols + "}", "u");
        }
    }
    else {
        if (pwUpper != null) {
            pwUpperRegex = new RegExp("(?:[^A-Z]*[A-Z]){" + pwUpper + "}");
        }
        if (pwLower != null) {
            pwLowerRegex = new RegExp("(?:[^a-z]*[a-z]){" + pwLower + "}");
        }
        if (pwDigits != null) {
            pwDigitsRegex = new RegExp("(?:\\d.*){" + pwDigits + "}");
        }
        if (pwLetters != null) {
            pwLettersRegex = new RegExp("(?:.*[a-zA-Z]){" + pwLetters + "}");
        }
        if (pwSymbols != null) {
            pwSymbolsRegex = new RegExp("(?:.*?[^a-zA-Z0-9]){" + pwSymbols + "}");
        }
    }

    $('#Password').keyup(function () {

        var input = $('#Password').val();

        applyClass(pwLength && pwLength <= input.length, '#pw-restriction-password-length'); // password length
        applyClass(pwLowerRegex && pwLowerRegex.test(input), '#pw-restriction-lower-case'); // lower case
        applyClass(pwUpperRegex && pwUpperRegex.test(input), '#pw-restriction-upper-case'); // upper case
        applyClass(pwDigitsRegex && pwDigitsRegex.test(input), '#pw-restriction-digits'); // digits
        applyClass(pwLettersRegex && pwLettersRegex.test(input), '#pw-restriction-letters'); // letters
        applyClass(pwSymbolsRegex && pwSymbolsRegex.test(input), '#pw-restriction-symbols') // symbols
    });
});